export default {
    name: "salary",
    data:function () {
        return {
            curr_job: {},
            Salary: '',
            ServantName: '',
            SalaryRange: '',
            SalaryRangeUnit: '元/月'
        }
    },
    methods:{
        init: function() {
          var _this = this;

          _this.curr_job = JSON.parse(window.sessionStorage.getItem("curr_job"));

          if (!_this.curr_job) { _this.$toast('出错了'); return; }

          //_this.checkCanApply();
          _this.ServantName = _this.$route.query.ServantName;
          _this.Salary = '';
          _this.SalaryRange = _this.curr_job.SalaryRange || '';
          _this.SalaryRangeUnit = _this.curr_job.SalaryRangeUnit || '';
        },

        apply:function () {
            var _this=this;
             if (!this.Salary) {
               _this.$toast('请输入薪资');
               return;
             }

            this.$post("/servant/applyforsalary",{
                "JobId": this.curr_job.JobId,
                "ServantAccountCode": this.$route.query.ServantAccountCode,
                "ProfileStoreId": this.$route.query.ProfileStoreId,
                "ServantName": this.$route.query.ServantName,
                "Salary": this.Salary

            },function (res) {
                if(res.Success){
                    _this.$toast('申请成功');
                }else{
                    _this.$toast(res.Message);
                }
            })
        },


        close:function () {
            this.$router.push({name:"jobDetail", query:{id: this.curr_job.JobId}});
        }
    },
    mounted:function(){
      this.init();
    },
    watch: {
      '$route': function (to, from) {
        if (to && to.name === 'salary'){
          this.init();
        }
      }
    }

}



// WEBPACK FOOTER //
// ./src/ally/page/home/salary.js